module.exports = __webpack_public_path__ + "media/images/soar/Criando_novo_encontro-69a47c09c3a3251899e50974dbdc95ee.gif";